export enum AddressTypes
{
    home = 239,
    office = 241,
    other = 242,
    work = 243
}